<template>
  <div class="page-wrap">
    <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>
    <v-alert v-if="success" type="success" dense outlined>{{ success }}</v-alert>
    <v-card class="pa-4 mb-4">
      <div class="d-flex align-center mb-3">
        <h1 class="text-h5 font-weight-bold mr-2">Conciliación de Cuentas a Cobrar</h1>
        <HelpHint text="Seleccioná líneas de la misma cuenta corriente cuyo neto sea 0 para conciliarlas. También podés revertir una conciliación por ID." />
      </div>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-text-field v-model="currentAccountId" dense outlined label="Cuenta Corriente ID" />
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn color="primary" @click="fetchRows">Buscar pendientes</v-btn>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="reversalId" dense outlined label="ID conciliación a revertir" />
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn color="warning" @click="reverseReconciliation">Revertir</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-4">
      <div class="d-flex align-center mb-2">
        <v-btn small color="success" :disabled="selected.length < 2" @click="reconcileSelected">Conciliar seleccionadas</v-btn>
        <span class="ml-3 caption">Seleccionadas: {{ selected.length }}</span>
      </div>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="rows"
        :loading="loading"
        item-key="id"
        show-select
        dense
      />
    </v-card>
  </div>
</template>

<script>
import { accountingService } from "@/services/accounting";
import HelpHint from "@/components/HelpHint.vue";

export default {
  name: "AccountingReconciliationView",
  components: { HelpHint },
  data() {
    return {
      loading: false,
      error: "",
      success: "",
      rows: [],
      selected: [],
      currentAccountId: "",
      reversalId: "",
      headers: [
        { text: "Fecha", value: "entryDate" },
        { text: "Ref Tipo", value: "referenceType" },
        { text: "Ref ID", value: "referenceId" },
        { text: "Débito Abierto", value: "openDebit" },
        { text: "Crédito Abierto", value: "openCredit" },
        { text: "Neto", value: "openSigned" },
      ],
    };
  },
  methods: {
    parseError(err) {
      return err?.response?.data?.error || err?.response?.data?.message || err?.message || "Error inesperado";
    },
    async fetchRows() {
      this.loading = true;
      this.error = "";
      try {
        const params = this.currentAccountId ? { currentAccountId: this.currentAccountId } : {};
        const { data } = await accountingService.listUnreconciledReceivables(params);
        this.rows = Array.isArray(data?.data) ? data.data : [];
      } catch (err) {
        this.error = this.parseError(err);
      } finally {
        this.loading = false;
      }
    },
    async reconcileSelected() {
      if (!this.currentAccountId || this.selected.length < 2) return;
      this.error = "";
      this.success = "";
      try {
        await accountingService.reconcileReceivables({
          currentAccountId: this.currentAccountId,
          lineIds: this.selected.map((x) => x.id),
          notes: "Conciliación desde frontend",
        });
        this.success = "Conciliación registrada correctamente.";
        this.selected = [];
        await this.fetchRows();
      } catch (err) {
        this.error = this.parseError(err);
      }
    },
    async reverseReconciliation() {
      if (!this.reversalId) return;
      this.error = "";
      this.success = "";
      try {
        await accountingService.unreconcileReceivables({ reconciliationId: this.reversalId });
        this.success = "Conciliación revertida correctamente.";
        this.reversalId = "";
        await this.fetchRows();
      } catch (err) {
        this.error = this.parseError(err);
      }
    },
  },
};
</script>

<style scoped>
.page-wrap { display: flex; flex-direction: column; gap: 12px; }
</style>
